import React from "react";
import { config } from "../../config/domain";
import { accRedircet } from "../../services/genralServise";
import NuvamaIcon from "../../assets/new_images/nuvama-logo.svg";

const Tnc = (props) => {
  const { updateTncStatus, postTncStatus, tncStatus } = props;

  const closeTnc = () => {
    accRedircet(config.root);
  };

  return (
    <div>
      <div className="termsCondition_header">
        <h5>
          <img src={NuvamaIcon} alt="nuvama-logo" />
        </h5>
        <div className="termsCondition_close">
          <i onClick={closeTnc} className="edel-icon-close"></i>
        </div>
      </div>
      <div className="termsCondition">
        <h5>Terms and Conditions</h5>
        <div className="termsCondition-border">
          <ul>
            <li>
              <p>
                I understand the risks involved in trading stock, commodity, and
                currency markets.
              </p>
            </li>
            <li>
              {" "}
              <p>
                I have read the{" "}
                <a
                  href={config.jmw_client_docs}
                  target="_blank"
                  rel="noreferrer"
                >
                  API Documentation
                </a>
                and have the technical know-how to use it.
              </p>
            </li>
            <li>
              <p>
                I understand the risks of my program not working as intended. I
                take full responsibility for any profits and losses that may
                arise while trading programmatically.
              </p>
            </li>
            <li>
              <p>
                I have read the{" "}
                <a
                  href={
                    process.env.PUBLIC_URL + "/tncDocs/terms-and-conditions.pdf"
                  }
                  target="_blank"
                  rel="noreferrer"
                >
                  Terms and Conditions
                </a>{" "}
                and accept it.
              </p>
            </li>
          </ul>
        </div>
        <div className="buttonSection">
          <div className="customRadio">
            <label className="containerInput">
              I Agree to the above terms
              <input type="checkbox" onChange={updateTncStatus} />
              <span className="checkmark"></span>
            </label>
          </div>
          <button
            className={`custom-btn block-btn ${tncStatus ? "" : "disable"}`}
            disabled={tncStatus ? false : true}
            onClick={postTncStatus}
          >
            <span>Proceed</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default Tnc;
